import {
	Box,
	Container,
	Flex,
	Heading,
	IconButton,
	Img,
	Link,
	Text,
} from "@chakra-ui/react";
import React from "react";
import { FaLinkedin } from "react-icons/fa";

const TheContextCreditWhere: React.FC = () => (
	<>
		{/* members */}
		<Flex
			as="section"
			flexDirection="column"
			overflow="hidden"
			justify="center"
			height={{ xs: "450px", sm: "300px" }}
			minH={{ xs: "450px", sm: "300px" }}
			maxH="450px"
			pos="relative"
		>
			<Img
				pos="absolute"
				objectFit="cover"
				src="/jpg/blogBanner.jpg"
				alt="members-hero"
				height="100%"
				width="100%"
			/>
			<Box
				bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
				pos="absolute"
				height="100%"
				width="100%"
				opacity="0.7"
			/>
			<Container
				display="flex"
				as="section"
				maxW="container.xl"
				position="relative"
				zIndex="1"
				flexDirection="column"
			>
				<Flex
					alignItems={{ xs: "flex-start", md: "flex-start" }}
					justifyContent="center"
					columnGap="24px"
					justifyItems="center"
					width="100%"
					display="flex"
					as="section"
					rowGap="30px"
					flexDir={{
						xs: "column",
						md: "row",
					}}
				>
					<Flex flexDir="column" rowGap="16px">
						<Heading
							color="white"
							fontSize={{ xs: "36px", sm: "42px", lg: "64px" }}
							fontWeight="800"
							lineHeight={{ xs: "35px", lg: "83px" }}
						>
							#TheContext
						</Heading>
					</Flex>
					<Box
						w="1.5px"
						h={{ xs: "100%" }}
						bgColor="white"
						display={{ xs: "none", md: "block" }}
					/>
					<Box
						w={{ xs: "70%", sm: "60%" }}
						h="1.5px"
						bgColor="white"
						display={{ xs: "block", md: "none" }}
					/>
					{/*  */}
					<Heading
						as="h1"
						mb={{ xs: "10px", md: "20px" }}
						variant="reportCardTitle"
						fontSize={{ xs: "27px", sm: "29px", md: "32px", lg: "54px" }}
						color="white"
						lineHeight={{ xs: "36px", sm: "40px", md: "46px", lg: "70.2px" }}
					>
						Credit Where Credit is Due
					</Heading>
				</Flex>
			</Container>
		</Flex>
		<Container
			as="section"
			maxW="container.xl"
			pb="80px"
			pt="40px"
			minH="420px"
			display={{ xs: "flex", md: "inherit" }}
			flexDirection="column"
		>
			<Box
				float={{ xs: "right", md: "left" }}
				alignSelf={{ xs: "center", md: "flex-start" }}
				mx={{ xs: "0px", md: "0px" }}
				mr={{ xs: "0px", md: "40px", lg: "60px", xl: "40px" }}
				mb="20px"
			>
				<Flex
					flexDir={{
						xs: "column",
						md: "row",
					}}
					gap="20px"
					alignItems={{
						xs: "center",
						md: "unset",
					}}
				>
					<Img
						src="https://static.levocdn.com/WGLBUT82/Screenshot2024-08-01at114817AM-yCrF3MWWXP1R.png"
						alt="Rahul Khanna"
						width="250px"
						height="250px"
						objectFit="cover"
						borderRadius="50%"
					/>
					<Flex direction="column">
						<Heading
							as="h1"
							fontWeight="800"
							pt="20px"
							variant="reportCardTitle"
							fontSize={{ xs: "16px", md: "18px", lg: "20px" }}
							textAlign={{
								xs: "center",
								md: "left",
							}}
						>
							Rahul Khanna
							<Link
								href="https://www.linkedin.com/in/khannarahul/"
								target="_blank"
								display={{ xs: "inline-block", md: "none" }}
								pl="10px"
							>
								<IconButton
									aria-label="linkedin"
									icon={<FaLinkedin size="28px" color="#067acc" />}
									variant="unstyled"
									cursor="pointer"
								/>
							</Link>
						</Heading>
						<Text
							color="text.mediumBlack"
							maxW={{
								xs: "100%",
								md: "120px",
							}}
							w="100%"
							fontSize="16px"
							lineHeight="22px"
							fontStyle="italic"
							textAlign={{
								xs: "center",
								md: "left",
							}}
						>
							Co-Founder and Managing Partner, Trifecta Capital
						</Text>

						<Link
							href="https://www.linkedin.com/in/khannarahul/"
							target="_blank"
							display={{
								xs: "none",
								md: "block",
							}}
						>
							<IconButton
								aria-label="linkedin"
								icon={<FaLinkedin size="28px" color="#067acc" />}
								variant="unstyled"
								cursor="pointer"
							/>
						</Link>
					</Flex>
				</Flex>
			</Box>
			<Box>
				<Box mt="16px" mb="20px">
					<Text variant="blogAnswer">
						The combination of ambitious talent, limitless potential for tech
						disruption, and the rapid expansion of mobile phone and internet
						infrastructure has driven venture capitalists to invest heavily in
						India&#39;s emerging startup ecosystem over the past decade.
						Following the pandemic-induced stimulus initiatives and the
						unprecedented growth in tech infrastructure and its adoption,
						venture capital funding surged dramatically during the funding
						supercycle of 2020 and 2021. However, this momentum slowed
						considerably over the last couple of years as investors shifted
						their focus from hypergrowth to profitability and capital
						efficiency. With many startups pivoting to more sustainable growth,
						investors are now picking up the pace on new investments and 2024
						will likely mark a change for the better in terms of financing for
						the ecosystem.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer">
						Even as the Indian venture capital industry has grown significantly,
						venture debt, a companion asset class, is now almost 10 years old
						with Trifecta Capital having launched India’s first venture debt
						fund in 2015. This asset class has scaled significantly by providing
						a non-dilutive financing solution for early and growth-stage
						companies that typically are not able to access credit facilities
						from traditional lenders like Banks and NBFCs. Equally, investors in
						this asset class have appreciated the relatively low-risk profile
						coupled with predictable quarterly returns and upside participation.
						As a pioneer in this asset class, Trifecta Capital has deployed over
						INR 6,000 crore across 180 companies through three venture debt
						funds. Now, the fundraising process for our fourth fund is also in
						full swing.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer">
						The last decade was largely dominated by equity financing provided
						by private equity and venture capital investors given the low cost
						of capital and the hypergrowth of startups. The next decade,
						however, is likely to be very attractive for private credit
						investors, especially those specialising in alternate capital for
						new-age companies for the reasons below.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer">
						Firstly, equity financiers over the last decade have created a
						massive pipeline of new-age companies for venture debt investors to
						support in the next phase of their growth. For example, for a Series
						B founder who has already diluted 50-60% of their equity, raising
						debt to fund the next phase of growth makes much more sense than
						just raising more equity. Following the pandemic peak and subsequent
						slowdown, companies are increasingly focusing on profitability and
						capital efficiency, creating an even better crop of companies for
						venture debt players to fund.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer">
						Secondly, venture debt is being used for various purposes such as
						inventory and receivables financing, working capital, capex, and
						deposits. Emerging use cases include acquisition financing and share
						buyback financing. These trends indicate that as the ecosystem
						matures, the demand for venture debt will continue to rise.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer">
						Thirdly, in more mature startup markets like the United States,
						venture debt makes up close to 20% of venture capital funding, while
						in India, the number barely touches 5%. At its peak, the US venture
						capital market crossed $300 billion in funding, compared to
						India&#39;s $30 billion. This highlights the significant growth
						potential for India&#39;s venture capital market and with it,
						massive growth potential of the venture debt market.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer">
						Trifecta Capital, as a venture debt investor, funded 63 companies in
						CY23, including 48 new companies and 15 follow-on investments,
						deploying close to 1200 crores. With a team of over 15 investment
						professionals in the key venture markets of Bangalore, Mumbai, and
						NCR we stay close to our portfolio companies and support their
						growth plans by leveraging our specialised expertise to steer
						founders and their companies toward long-term value creation.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer">
						With enormous depth yet to be achieved, the current venture debt
						market is just a fraction of its potential in the coming decades.
						Trifecta Capital, as the pioneer and market leader is well
						positioned to capitalise on the growth of this asset class by
						providing innovative financing solutions to companies through their
						lifecycle.
					</Text>
				</Box>
			</Box>

			<Box width="100%" height="2px" bgColor="primary.200" />
			<Text
				variant="blogAnswer"
				lineHeight="30px"
				pt="18px"
				fontStyle="italic"
				p="12px 12px 0px"
				fontWeight="500"
			>
				<Text as="span" fontWeight="700" fontStyle="normal">
					#TheContext by IVCA
				</Text>{" "}
				– features opinion makers from the alternate investing industry with
				strong focus on India as an investment destination. Watch this space for
				new announcements in the sector, viewpoints on investment themes,
				emerging trends, economic reports, analysis and latest industry
				insights.
			</Text>
			<Heading
				variant="blogQuestion"
				lineHeight="30px"
				pt="16px"
				fontStyle="italic"
				p="12px 12px 0px"
			>
				Content in this section is curated by team IVCA. To share feedback,
				connect with&nbsp;
				{/* The content in this section is curated by Team IVCA. For any feedback,
        connect with&nbsp; */}
				<Link
					href="mailto:paromita.sinha@ivca.in"
					target="_blank"
					style={{ color: "blue", textDecoration: "underline" }}
				>
					paromita.sinha@ivca.in
				</Link>
			</Heading>
		</Container>
	</>
);

export default TheContextCreditWhere;
